import React, { useState, forwardRef } from 'react';
import { ChevronDown, Check, Calendar, FileText } from 'lucide-react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const CustomDateInput = forwardRef(({ value, onClick }, ref) => (
    <span className="font-medium flex items-center cursor-pointer" onClick={onClick} ref={ref}>
        <Calendar size={18} className="mr-2 text-[#526477]" />
        Date- {value}
        <ChevronDown size={20} className="ml-2 text-[#111827]" />
    </span>
));

CustomDateInput.displayName = 'CustomDateInput';

const DashboardHeader = ({ projectName, date, onProjectChange, onDateChange, projects = [], reportMonthText, onViewSample }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6">
            {/* Project Selector - Dropdown */}
            <div className="relative z-50 w-full md:w-auto">
                <button
                    onClick={() => setIsOpen(!isOpen)}
                    className="flex items-center justify-between px-4 py-2 bg-transparent border border-[#526477] rounded-md text-[#111827] font-bold text-base w-full md:min-w-[280px] hover:bg-gray-50 transition-colors"
                >
                    <span>{projectName || 'Select Project'}</span>
                    <ChevronDown size={20} className={`ml-2 text-[#111827] transition-transform ${isOpen ? 'rotate-180' : ''}`} />
                </button>

                {isOpen && (
                    <div className="absolute top-full left-0 mt-2 w-full bg-white border border-gray-100 rounded-lg shadow-xl py-1 overflow-hidden animate-in fade-in zoom-in-95 duration-100 max-h-[300px] overflow-y-auto">
                        {projects.length > 0 ? (
                            projects.map((project) => (
                                <button
                                    key={project.id || project.value}
                                    className="w-full text-left px-4 py-2.5 hover:bg-gray-50 text-sm font-medium text-gray-700 flex justify-between items-center transition-colors"
                                    onClick={() => {
                                        if (onProjectChange) onProjectChange(project.label);
                                        setIsOpen(false);
                                    }}
                                >
                                    {project.label}
                                    {projectName === project.label && <Check size={16} className="text-[#1F4B55]" />}
                                </button>
                            ))
                        ) : (
                            <div className="px-4 py-2 text-sm text-gray-500">No projects found</div>
                        )}
                    </div>
                )}
            </div>

            {/* View Sample + Date/Time Info */}
            <div className="flex flex-wrap items-center gap-3">
                {onViewSample && (
                    <button
                        type="button"
                        onClick={onViewSample}
                        className="flex items-center gap-2 px-4 py-2 bg-[#1F4B55] text-white rounded-md text-sm font-semibold hover:bg-[#163a42] transition-colors"
                    >
                        <FileText size={18} />
                        View Sample
                    </button>
                )}
                <div className="flex items-center bg-transparent border border-[#526477] rounded-md px-4 py-2 text-base text-[#111827] font-bold hover:bg-gray-50 transition-colors w-full md:w-auto justify-between md:justify-start">
                {reportMonthText && (
                    <>
                        <span className="font-medium mr-2">{reportMonthText}</span>
                        <span className="h-4 w-px bg-[#000000] mx-2 hidden md:block"></span>
                    </>
                )}
                <DatePicker
                    selected={date}
                    onChange={(d) => onDateChange && onDateChange(d)}
                    customInput={<CustomDateInput />}
                    dateFormat="MMMM yyyy"
                    showMonthYearPicker
                    maxDate={new Date(new Date().getFullYear(), new Date().getMonth(), 0)}
                    popperPlacement="bottom-end"
                    popperClassName="!z-[60]"
                />
                </div>
            </div>
        </div>
    );
};

export default DashboardHeader;
